import { render, staticRenderFns } from "./DataElementPreview.vue?vue&type=template&id=94afb50a"
import script from "./DataElementPreview.vue?vue&type=script&lang=js"
export * from "./DataElementPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports